"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _helpers = require("../../../utils/helpers");

var _Logo = require("./Logo.style");

var _Typography = require("../../Typography");

var Logo = function Logo(_ref) {
  var homeLink = _ref.homeLink,
      logoImage = _ref.logoImage,
      logoTitle = _ref.logoTitle,
      logoAlt = _ref.logoAlt;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      colors = _ref2.colors,
      name = _ref2.name,
      nav = _ref2.nav,
      slug = _ref2.slug;

  var BrandLogo = (0, _helpers.getLogo)(slug);
  var logoProps = logoImage ? _objectSpread(_objectSpread({}, logoImage), {}, {
    height: nav.logo.height,
    src: logoImage.fluid ? logoImage.fluid.src : logoImage.src,
    title: logoTitle,
    alt: logoAlt
  }) : {
    color: colors[nav.logo.color],
    height: nav.logo.height,
    width: nav.logo.width,
    title: logoTitle,
    alt: logoAlt
  };
  return /*#__PURE__*/_react.default.createElement(_Logo.LogoLink, {
    to: homeLink,
    "aria-label": "".concat(name, " Home")
  }, logoImage ? /*#__PURE__*/_react.default.createElement(_Logo.LogoImage, logoProps) : /*#__PURE__*/_react.default.createElement(BrandLogo, logoProps), /*#__PURE__*/_react.default.createElement(_Typography.ScreenReaderOnly, null, name, " Logo"));
};

Logo.propTypes = {
  homeLink: _propTypes.default.string,
  logoImage: _propTypes.default.shape({
    /** Fluid image object */
    fluid: _propTypes.default.shape({
      base64: _propTypes.default.string.isRequired,
      aspectRatio: _propTypes.default.number.isRequired,
      src: _propTypes.default.string.isRequired,
      srcSet: _propTypes.default.string.isRequired,
      srcSetWebp: _propTypes.default.string.isRequired,
      sizes: _propTypes.default.string.isRequired
    }),

    /** File src of image object in case we dont have a fluid obj */
    src: _propTypes.default.string
  }),
  logoTitle: _propTypes.default.string,
  logoAlt: _propTypes.default.string
};
Logo.defaultProps = {
  homeLink: '/',
  logoImage: null,
  logoTitle: 'logo',
  logoAlt: 'logo'
};
var _default = Logo;
exports.default = _default;